import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Icon from '../../../components/AppIcon';

const EmailActionsModal = ({ isOpen, onClose }) => {
  const actions = [
    {
      id: 'compose-email',
      icon: 'Mail',
      label: 'كتابة بريد إلكتروني',
      description: 'إنشاء بريد جديد',
      color: '#F59E0B'
    },
    {
      id: 'ai-compose',
      icon: 'Sparkles',
      label: 'كتابة بالذكاء الاصطناعي',
      description: 'توليد بريد احترافي باستخدام OpenAI',
      color: '#10B981'
    },
    {
      id: 'email-campaign',
      icon: 'Send',
      label: 'حملة بريدية',
      description: 'إرسال حملة تسويقية',
      color: '#EC4899'
    },
    {
      id: 'templates',
      icon: 'FileText',
      label: 'قوالب البريد',
      description: 'استخدام قوالب جاهزة',
      color: '#8B5CF6'
    },
    {
      id: 'ai-reply',
      icon: 'Reply',
      label: 'رد ذكي',
      description: 'توليد ردود تلقائية باستخدام AI',
      color: '#3B82F6'
    },
    {
      id: 'schedule-email',
      icon: 'Clock',
      label: 'جدولة إرسال',
      description: 'جدولة بريد إلكتروني',
      color: '#06B6D4'
    }
  ];

  const integrations = [
    {
      id: 'openai-compose',
      icon: 'Brain',
      label: 'OpenAI للكتابة',
      description: 'كتابة رسائل احترافية تلقائياً',
      enabled: true
    },
    {
      id: 'grammar-check',
      icon: 'CheckCircle',
      label: 'تدقيق لغوي',
      description: 'تصحيح الأخطاء اللغوية والنحوية',
      enabled: true
    },
    {
      id: 'spam-checker',
      icon: 'Shield',
      label: 'فحص البريد المزعج',
      description: 'التأكد من عدم تصنيف البريد كمزعج',
      enabled: true
    },
    {
      id: 'open-tracking',
      icon: 'Eye',
      label: 'تتبع الفتح',
      description: 'معرفة من فتح البريد',
      enabled: false
    }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="إجراءات البريد الإلكتروني"
      size="lg"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-6" dir="rtl">
        <div>
          <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
            <Icon name="Zap" size={20} color="#F59E0B" />
            الإجراءات المتاحة
          </h3>
          <div className="grid grid-cols-2 gap-3">
            {actions?.map((action) => (
              <button
                key={action?.id}
                className="p-4 bg-gray-800/50 hover:bg-gray-700/50 border border-gray-700 rounded-xl transition-all text-right"
              >
                <div className="flex items-start gap-3">
                  <div
                    className="p-2 rounded-lg"
                    style={{ backgroundColor: `${action?.color}20` }}
                  >
                    <Icon name={action?.icon} size={20} color={action?.color} />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white font-semibold text-sm mb-1">
                      {action?.label}
                    </h4>
                    <p className="text-gray-400 text-xs">
                      {action?.description}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
            <Icon name="Plug" size={20} color="#3B82F6" />
            التكاملات والخيارات
          </h3>
          <div className="space-y-3">
            {integrations?.map((integration) => (
              <div
                key={integration?.id}
                className="p-4 bg-gray-800/50 border border-gray-700 rounded-xl flex items-center justify-between"
              >
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-blue-500/20 rounded-lg">
                    <Icon name={integration?.icon} size={18} color="#3B82F6" />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm">
                      {integration?.label}
                    </h4>
                    <p className="text-gray-400 text-xs">
                      {integration?.description}
                    </p>
                  </div>
                </div>
                <div
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    integration?.enabled
                      ? 'bg-green-500/20 text-green-400' :'bg-gray-700 text-gray-400'
                  }`}
                >
                  {integration?.enabled ? 'مفعّل' : 'معطّل'}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3">
          <div className="p-3 bg-orange-500/10 border border-orange-500/30 rounded-lg text-center">
            <div className="text-2xl font-bold text-orange-400">54</div>
            <div className="text-xs text-gray-400 mt-1">رسائل مرسلة</div>
          </div>
          <div className="p-3 bg-green-500/10 border border-green-500/30 rounded-lg text-center">
            <div className="text-2xl font-bold text-green-400">78%</div>
            <div className="text-xs text-gray-400 mt-1">معدل الفتح</div>
          </div>
          <div className="p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg text-center">
            <div className="text-2xl font-bold text-blue-400">23</div>
            <div className="text-xs text-gray-400 mt-1">ردود مستلمة</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EmailActionsModal;